import { render, staticRenderFns } from "./WidgetCustomize.vue?vue&type=template&id=5a55a0d8"
import script from "./WidgetCustomize.vue?vue&type=script&lang=js"
export * from "./WidgetCustomize.vue?vue&type=script&lang=js"
import style0 from "./WidgetCustomize.vue?vue&type=style&index=0&id=5a55a0d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports